import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CenterService from '@/services/centers/center.service.js'
import useInputs from '@/utils/hooks/useInputs.js'
import swalAlert from '@/utils/helpers/swalAlert.js'
import CenterSettingsService from '@/services/settings/centers/centerSettings.service.js'
import EntityDropdown from '@/component/form/EntityDropdown.tsx'
import AppDateInput from '@/component/form/AppDateInput.tsx'
import { Group, Stack } from '@mantine/core'
import { AppModalContent } from '@/component/layout/AppModal.tsx'
import AppButton from '@/component/common/AppButton.tsx'

const CenterMaintenanceForm = ({ centerId, selectedItem, close }) => {
  const { t } = useTranslation()

  const { inputs, onChangeInputs, updateInputs } = useInputs()

  const [maintenanceTypes, setMaintenanceTypes] = useState()

  useEffect(() => {
    getCenterMaintenanceTypes()
  }, [])

  useEffect(() => {
    // console.log(selectedItem)
    if (selectedItem?._id) {
      updateInputs(selectedItem)
    }
    // TODO: Como cargar en inputs?.files el archivo existente?
  }, [selectedItem])

  const getCenterMaintenanceTypes = async () => {
    const response = await CenterSettingsService.maintenanceTypes.getAll({})
    if (response) {
      setMaintenanceTypes(response.resp)
    }
  }

  const handleSave = async () => {
    // console.log('handleSave', selectedItem)
    if (centerId && centerId !== 'undefined') {
      // console.log('inputs', inputs)
      const data = {
        ...inputs,
      }
      const response = inputs?._id
        ? await CenterService?.maintenances?.update({
            id: centerId,
            rowId: inputs?._id,
            body: data,
          })
        : await CenterService?.maintenances?.create({
            id: centerId,
            body: data,
          })
      // console.log('response', response)
      if (response) {
        close()
        // updateInputs(response?.resp)
      }
    }
  }

  const handleRemove = async () => {
    const confirm = await swalAlert.warning(
      t('button.delete'),
      t('button.cancel'),
      t('button.delete'),
    )
    if (confirm?.isConfirmed) {
      const response = await CenterService?.maintenances?.remove({
        id: centerId,
        rowId: inputs?._id,
      })
      if (response) {
        close()
      }
    }
  }

  return (
    <AppModalContent
      buttons={[
        inputs?._id && <AppButton preset="remove" onClick={handleRemove} />,
        <AppButton preset="save" onClick={handleSave} />,
      ]}
      content={
        <Stack w="100%">
          <Group w="100%">
            <EntityDropdown
              icon="technics"
              label="maintenanceType"
              withAsterisk
              name="maintenanceTypeId"
              value={inputs?.maintenanceTypeId}
              options={maintenanceTypes}
              onChange={onChangeInputs}
            />
          </Group>
          <Group w="100%" justify="space-between">
            <AppDateInput
              label="revisionDate"
              name="revisionDate"
              value={inputs?.revisionDate}
              onChange={onChangeInputs}
            />
            <AppDateInput
              label="endDate"
              name="endDate"
              value={inputs?.endDate}
              onChange={onChangeInputs}
            />
          </Group>
        </Stack>
      }
    />
  )
}

export default CenterMaintenanceForm
